import axios from 'axios';
import { IVerifyEligibilityRequest } from '@lib/types';
import { LogCannon } from '@ace-clublabs/log-cannon';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { VerifyEligibility } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const VerifyEligibilityApi =
  (endpoint: string): VerifyEligibility =>
  async ({ membershipNumber, zipCode, appFlow, brokerRegion }: IVerifyEligibilityRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('VerifyEligibilityApi scenario', { scenario });

      LogCannon.blast('VerifyEligibilityApi start', { endpoint, membershipNumber, zipCode, brokerRegion });
      const { data, status } = await axios.post(
        `${endpoint}`,
        {
          membershipNumber,
          zipCode,
          appFlow,
          brokerRegion,
        },
        createAxiosConfig(scenario, endpoint)
      );
      LogCannon.blast('VerifyEligibilityApi success');
      return Promise.resolve({ ...data, status });
    } catch (error: any) {
      LogCannon.error('VerifyEligibilityApi error', { error: error?.message });
      if (error.response) {
        const autoPayAlreadyEnrolled = error.response.data?.error?.data?.isEnrolledInAutoPay;
        const canEnrollInAutoPay = error.response.data?.error?.data?.canEnrollInAutoPay;
        const clubCode = error.response.data?.error?.data?.clubCode;
        const isBotDetectionResponse = error.response.status === 403 && !!error.response.data?.pxEvent;

        let type = ErrorType.SYSTEM_ERROR;
        let data: any = clubCode ? { clubCode } : undefined;
        if (autoPayAlreadyEnrolled) {
          type = ErrorType.AUTOPAY_ALREADY_ENROLLED;
        } else if (autoPayAlreadyEnrolled === false && canEnrollInAutoPay === false) {
          type = ErrorType.INELIGIBLE_FOR_AUTOPAY;
        } else if (isBotDetectionResponse) {
          type = ErrorType.BOT_ERROR;
        }

        return Promise.reject({
          message: error.response.data?.message,
          requestId: error.response.data?.requestId,
          type,
          data,
        });
      } else {
        return Promise.reject({
          message: error,
        });
      }
    }
  };
